import toJS from 'components/common/toJS';
import { composeTimeCategories, getTimeLabelFormatter } from 'components/dashboard/common/periods';
import ThreeValuesWidgetHeader from 'components/dashboard/common/ThreeValuesWidgetHeader';
import ValueOverTimeChart from 'components/dashboard/common/ValueOverTimeChart';
import Widget from 'components/dashboard/common/Widget';
import useSettingsChangeActionDispatcher from 'components/dashboard/location/useSettingsChangeActionDispatcher';
import COLORS from 'components/style/colors';
import { get } from 'lodash';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { getUserTimezone } from 'reducers/auth';
import { actions, getReport, getRequestDate, isReportFetching } from 'reducers/dashboard/location/returningCustomers';

const newColor = COLORS.LIGHT_BLUE;
const returningColor = COLORS.DARK_YELLOW;

function ReturningCustomersWidget({
  location,
  history,
  isFetching,
  requestDate,
  userTimezone,
  report,
  reportRequest,
  defaultLocationId,
}) {
  const [period, timezone] = useSettingsChangeActionDispatcher(
    location,
    history,
    userTimezone,
    reportRequest,
    defaultLocationId
  );

  if (!requestDate) {
    return null;
  }

  const series = report && [report.new, report.returning];
  const categories = composeTimeCategories(requestDate, timezone, period);

  return (
    <Widget title="First time vs return">
      <>
        <ThreeValuesWidgetHeader
          left={{ name: 'First time', value: get(report, 'new.value'), color: newColor }}
          right={{ name: 'Return', value: get(report, 'returning.value'), color: returningColor }}
        />
        <ValueOverTimeChart
          isFetching={isFetching}
          type="bar"
          stack="one"
          categories={categories}
          categoriesFormatter={getTimeLabelFormatter(requestDate, timezone, period)}
          series={series}
        />
      </>
    </Widget>
  );
}

function mapStateToProps(state) {
  return {
    isFetching: isReportFetching(state),
    requestDate: getRequestDate(state),
    report: getReport(state),
    userTimezone: getUserTimezone(state),
  };
}

export default withRouter(
  connect(mapStateToProps, { reportRequest: actions.reportRequest })(toJS(ReturningCustomersWidget))
);
